import axios, { InternalAxiosRequestConfig } from 'axios';

import { errorHandler, responseHandler } from './http-common';

import { cultureApiAddress } from '../config';

const TIMEOUT = 15000;

const requestHandler = (request: InternalAxiosRequestConfig) => {
    request.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    return request;
};

const axiosCultureAPI = axios.create({
    baseURL: cultureApiAddress,
    timeout: TIMEOUT,
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosCultureAPI.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => errorHandler(error),
);

axiosCultureAPI.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => Promise.reject(errorHandler(error)),
);

export default axiosCultureAPI;
